import { usePage } from "@inertiajs/react"
import { useEffect, useRef } from "react"

import { trackGoal } from "@/lib/track-goal"
import type { SharedData } from "@/types"

// Fires once per return or sign-in result. The layout stays mounted across
// Inertia visits, so the last id is cleared when the prop goes away.
export function CheckoutEvents() {
  const { checkout_purchase, checkout_sign_in } = usePage().props as SharedData
  const lastPurchase = useRef<string | null>(null)
  const lastSignIn = useRef<string | null>(null)

  useEffect(() => {
    const transactionId = checkout_purchase?.transaction_id
    if (!transactionId) {
      lastPurchase.current = null
      return
    }
    if (lastPurchase.current === transactionId) return
    lastPurchase.current = transactionId

    const props: Record<string, string> = {
      gifted: String(Boolean(checkout_purchase?.gifted)),
    }
    if (checkout_purchase?.plan_name) props.plan = checkout_purchase.plan_name
    trackGoal("checkout_return", props)
  }, [checkout_purchase])

  useEffect(() => {
    if (checkout_sign_in !== "succeeded" && checkout_sign_in !== "failed") {
      lastSignIn.current = null
      return
    }
    if (lastSignIn.current === checkout_sign_in) return
    lastSignIn.current = checkout_sign_in
    trackGoal("checkout_sign_in", { result: checkout_sign_in })
  }, [checkout_sign_in])

  return null
}
